import React, { useState } from 'react'
import '../../cssHelper/helper.css'
import './Header.css'
import { searchQuery } from '../../redux/redux'
import { useDispatch } from 'react-redux'

function Header() {
    const dispatch = useDispatch();
    const [query, setQuery] = useState();
    const handleQuery = (e) => {
        setQuery(e.target.value)
    }
    const sendQuery = (e) => {
        e.preventDefault()
        dispatch(searchQuery(query))
    }
    return (
        <div className='Header flex j-between pl-14 a-center white-clr w-full pr-2'>
             <span className="span none">
                <span class="material-symbols-rounded">
                    menu
                </span>
            </span>
            <div className="search relative r-vh">
                <form onSubmit={sendQuery} className='flex a-center h-full'>
                    <input
                        type="search"
                        className='search-input font-sm pl-1 h-full glass white-clr r-vh w-full'
                        name='query'
                        placeholder='Search'
                        value={query}
                        onChange={handleQuery}
                    />
                </form>
                <div className="search-icon absolute abs-mid-y pointer span flex j-center a-center right">
                    <span class="material-symbols-rounded">
                        search
                    </span>
                </div>
            </div>
            <div className="flex gap-1 span s a-center">
                <span class="material-symbols-rounded mob-search">
                    search
                </span>
                <span class="material-symbols-rounded">
                    stylus_note
                </span>
                <span class="material-symbols-rounded">
                    notifications
                </span>
                <img src="https://yt3.ggpht.com/4cJcy56H7KATa58vms162G5g10xp9avyO03yPPbsOadk3tLX7txLZaVWWN-QtIovt5FnURyx=s88-c-k-c0x00ffffff-no-rj" alt="" className="img-1 cover r-50" />
            </div>
        </div>
    )
}

export default Header
